import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import ChoosePlan from './ChoosePlan'
import type { PropsType, DispatchPropsType } from './ChoosePlan'
import { changePlanAction } from '../../../../../actions/subscriptionActions'
import type { AppStateType } from '../../../../../reducers/appstate'

type OwnPropsType = {
  header?: string,
  subHeader?: string,
  isPromoFlowPrice?: boolean
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): PropsType => {
  return {
    header: ownProps.header || state.textSubscriptionModalHeader,
    subHeader: ownProps.subHeader,
    textPaywallValueProps: state.textPaywallValueProps,
    textAnnualArialLabel: state.textAnnualArialLabel,
    textMonthlyCtaWebApp: state.textMonthlyCtaWebApp,
    textMonthlyArialLabel: state.textMonthlyArialLabel,
    plan: state.subscriptionPurchase.plan,
    price: state.subscriptionText.price,
    showHover: state.hasMouse,
    promoValid: (state.subscriptionPromo || {}).valid,
    isPromoFlowPrice: ownProps.isPromoFlowPrice
  } as PropsType
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    choosePlan: (plan: 'monthly' | 'annual'): void => dispatch(changePlanAction(plan))
  } as DispatchPropsType
}

export default connect(mapStateToProps, mapDispatchToProps)(ChoosePlan)
